const lib = require('./lib/cjs/main'); // eslint-disable-line import/no-unresolved, import/extensions

module.exports = lib;
exports = module.exports;
exports.default = lib;
